import React from "react";
import { ArchiveConfirmConsts } from "./constants";
import { CommonButtonTexts } from "../../../enums/ButtonAttributesEnums";
import InputField from "../../../reusable-components/TNInputField";
import { InputfieldTypes } from "../../../enums/InputFieldAttributesEnums";
import TNLoader from "../../../reusable-components/TNLoader";
import { message, Modal } from "antd";
import { useFormContext } from "react-hook-form";
import { useQueryClient } from "@tanstack/react-query";
import JobDatabaseService from "../../../services/jobDatabase.service";
import { QueryKeys } from "../../../constants/QueryKeys";

export interface ArchiveConfirmModalProps {
  isOpen?: boolean;
  handleClose: () => void;
  jobId?: string;
}

const ArchiveConfirmModal = ({
  isOpen,
  handleClose,
  jobId,
}: ArchiveConfirmModalProps) => {
  const {
    reset,
    getValues,
    control: { handleSubmit },
  } = useFormContext();
  const queryClient = useQueryClient();
  const {
    TITLE,
    MESSAGE,
    REASON_NAME,
    REASON_LABEL,
    REASON_PLACEHOLDER,
    ARCHIVE_SUCCESS,
    MODAL_WITH,
  } = ArchiveConfirmConsts;

  const { ArchiveJobDatabaseEntry } = JobDatabaseService();

  const { mutateAsync: archiveJob, isPending } = ArchiveJobDatabaseEntry();

  const handleSubmitAction = async () => {
    const payload = {
      id: jobId,
      notes: getValues(REASON_NAME),
    };
    await archiveJob(payload, {
      onSuccess: () => {
        message.success(ARCHIVE_SUCCESS);
        queryClient.invalidateQueries([
          QueryKeys.FETCH_JOB_DATABASE_LISTING_KEY,
          QueryKeys.FETCH_JOB_DATABASE_SUMMARY_KEY,
        ]);
      },
    });
    reset();
    handleClose();
  };

  const handleCancel = () => {
    reset();
    handleClose();
  };

  return (
    <>
      <TNLoader isLoading={isPending} />
      <Modal
        title={TITLE}
        okText={CommonButtonTexts.CONFIRM}
        visible={isOpen}
        onCancel={handleCancel}
        onOk={handleSubmit(() => handleSubmitAction())}
        width={MODAL_WITH}
        loading={false}
      >
        <div>{MESSAGE}</div>
        <InputField
          type={InputfieldTypes.TEXT_AREA}
          name={REASON_NAME}
          label={REASON_LABEL}
          maxLength={500}
          textAreaRows={6}
          requiredField
          noResize
          placeholder={REASON_PLACEHOLDER}
        />
      </Modal>
    </>
  );
};

export default ArchiveConfirmModal;
